import {
  DiscreetTypography
} from "./chunk-X3MX6SC5.js";

// lib/build/clientBuildNumber.ts
var clientBuildNumber = () => {
  if (process.env.BUILD_NUMBER === void 0) {
    throw new Error("Missing process.env.BUILD_NUMBER");
  }
  return {
    build: {
      number: process.env.BUILD_NUMBER
    }
  };
};

// lib/build/buildNumber.tsx
import { jsxs } from "react/jsx-runtime";
var BuildNumber = ({ sx }) => {
  const buildNumber = clientBuildNumber();
  return /* @__PURE__ */ jsxs(DiscreetTypography, { sx, children: [
    "Build ",
    buildNumber.build.number
  ] });
};

export {
  clientBuildNumber,
  BuildNumber
};
